import { CommonModule } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';

import { TooltipDirectiveModule } from '@toro/common/shared/directives/tooltip/tooltip.module';
import { TrSpinnerButtonDirectiveModule } from '@toro/common/shared/directives/tr-spinner-button/tr-spinner-button.module';

import { ChartsModule } from '../app/components/charts/charts.module';

import { TextUtils } from '@toro/common/shared/resources/text.utils';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';

import { SharedResourcesModule } from '@toro/common/shared/resources/resources.module';

import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';

registerLocaleData(ptBr);
@NgModule({
    imports: [
        CommonModule,
        MatSelectModule,
        MatChipsModule,
        TrSpinnerButtonDirectiveModule,
        TooltipDirectiveModule,
        ChartsModule,
    ],
    declarations: [
    ],
    exports: [
        MatSelectModule,
        MatChipsModule,
        ChartsModule,
        SharedResourcesModule,
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'pt' },
        DialogsService,
        TextUtils,
    ],
})
export class GlobalModule { }
